import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';

@Component({
  selector: 'app-top-active-customer',
  templateUrl: './top-active-customer.component.html',
  styleUrls: ['./top-active-customer.component.scss']
})
export class TopActiveCustomerComponent extends BaseComponent implements OnInit {

  period: number=0;
  chartData: number[]=[];
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'horizontalBar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];

  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true 
  // };

public barChartOptions: any = {
  responsive: true,
  maintainAspectRatio: false,

  // 🔎 Tooltip: show only the hovered segment (one value)
  tooltips: {
    mode: 'nearest',    // 👈 NOT 'dataset'
    intersect: true,
    callbacks: {
      // For horizontalBar in v2, xLabel is the numeric value, yLabel is the category
      label: function (tooltipItem, data) {
        const ds = data.datasets[tooltipItem.datasetIndex] || {};
        const label = ds.label ? `${ds.label}: ` : '';
        return `${label}${tooltipItem.xLabel}`;
      }
    }
  },

  // Match hover behavior with tooltip
  hover: {
    mode: 'nearest',
    intersect: true
  },

  legend: {
    display: true,
    position: 'right'
  },

  // ✅ Make stacking explicit on both axes
  scales: {
    xAxes: [{
      stacked: true,            // 👈 turn stacking ON
      ticks: { beginAtZero: true }
    }],
    yAxes: [{
      stacked: true             // 👈 turn stacking ON
    }]
  }
};


  items = [];
  colorCount:number;
  months=[];
  constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService
      ){ 
        
        super();
  }

  ngOnInit(): void {
   // alert("ngOnInit");
   // this.items.push({reportFromDate: "", reportToDate: "", period: 1, year: "", month: "", implementation: "", service: ""});
    //alert(this.items.length);
    
  }
   CreateChartSelectedDateWise()  {    
            
      this.barChartData =[];
      this.chartData=[];
      this.barChartLabels=[];
      this.months=[];
      if(this.items.length>0)
      {
          console.log("period",this.items[0]["period"])
        this.reportAnalyticsService.GetReport(this.items[0]["reportFromDate"],this.items[0]["reportToDate"],this.items[0]["period"],this.items[0]["year"],this.items[0]["month"],"TopActiveCustomerReport").subscribe(
        ress => {
          this.loaderService.hide();
          if (ress.successed) {
            var data = ress.data;
            
              //#region  Barchart
              if(data.customerReport[0].subColumnName === "undefined" || data.customerReport[0].subColumnName === null){
              //console.log("if");
                this.barChartLegend=false;
                this.barChartColors=[{backgroundColor:(this.chartService.getColors(1))}] ;
                for (let i = 0; i < data.customerReport.length; i++) {

                    this.barChartLabels.push(data.customerReport[i].columnName)
                    this.chartData.push(data.customerReport[i].columnValue)
                }

                this.barChartData=[{data:this.chartData,label:"TopActiveCustomer"}];
                console.log("barChartData",this.barChartData);
                console.log("barChartLabels",this.barChartLabels);
              }
            
              else if(data.customerReport[0].customerName !== "undefined" && data.customerReport[0].customerName !== null){

                this.barChartData=[];              
                this.barChartLegend=true;

                interface RawData {
                  columnName: string;
                  subColumnName: string;
                  customerName: string;
                  columnValue: number | string;
                }

                const rawData: RawData[] = (data.customerReport || []) as RawData[];
              

                const monthsColumn = data.customerReport.filter(
                  (customerReport, i, arr) => arr.findIndex(t => t.subColumnName === customerReport.subColumnName) === i
                );
                for (let mc = 0; mc < monthsColumn.length; mc++) {
                  
                  this.months.push(monthsColumn[mc].subColumnName);
                }
              
                const months =this.months;// [...monthOrder];
                const customer = Array.from(new Set(rawData.map(r => r.customerName))).sort();
                const years = Array.from(new Set(rawData.map(r => r.columnName))).sort();
                
                function getData(year: string, month: string, customer: string) {
                  const matches = rawData.filter(r =>
                    String(r.columnName) === String(year) &&
                    String(r.subColumnName) === String(month) &&
                    String(r.customerName) === String(customer)
                  );
                  return matches.reduce((acc, r) => acc + (Number(r.columnValue) || 0), 0);
                }
                this.colorCount=1;
                const datasets: any[] = [];
                customer.forEach((customer, idx) => {
                  
                  years.forEach((year, yIdx) => {
                    const colors = this.chartService.getChartColors(this.colorCount);                  
                    const dataForMonths = months.map(m => getData(year, m, customer));
                    this.colorCount++;
          
                    if (dataForMonths.every(v => v === 0)) return;

                    datasets.push({
                      label: `${customer} (${year})`,
                      implLabel: customer,year,
                      data: dataForMonths,
                      backgroundColor: colors.base,
                      hoverBackgroundColor: colors.hover,
                      stack: year,
                      barPercentage: 0.8,
                      categoryPercentage: 0.9,

                    });
                  });
                });
                this.barChartLegend = true;
                this.barChartLabels = months;
                this.barChartData = datasets;
              
                console.log("this.barChartData -" ,this.barChartData);
                console.log("this.barChartLabels",this.barChartLabels);

        
                
              }
              else
              {
                this.barChartData=[];              
                this.barChartLegend=true;
                const distinctColumn = data.customerReport.filter(
                  (customerReport, i, arr) => arr.findIndex(t => t.columnName === customerReport.columnName) === i
                );
              
                for (let dc = 0; dc < distinctColumn.length; dc++) {
                    this.barChartColors=[];
                    this.barChartLabels=[];
                    this.chartData=[];

                  // alert(this.chartService.getColors(dc+1));
                    this.barChartColors.push(this.chartService.getColors(dc+1)) ;
                    this.colorCount=0;
                  for (let i = 0; i < data.customerReport.length; i++) {

                  if(distinctColumn[dc].columnName === data.customerReport[i].columnName)
                  {
                    this.barChartLabels.push(data.customerReport[i].subColumnName)
                    this.chartData.push(data.customerReport[i].columnValue)
                    this.colorCount++;
                    console.log("barChartData",data.customerReport[i].subColumnName);
                  }
                  
                  }
                  this.barChartData.push({data:this.chartData,label:distinctColumn[dc].columnName});
                }

                //console.log("barChartData",this.barChartData);
                //console.log("barChartLabels",this.barChartLabels);
              }
              //#endregion

          } else {
            this.toastrAlertService.errorToastr(ress.errorMessage);
          }
        },
        error => {
          this.loaderService.hide();
          if (typeof error.error !== "undefined") {
            this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
          }
        }
        )
          this.barChartData =[];
          this.chartData=[];
          this.barChartLabels=[];
          this.barChartData=[];
          this.items=[];
          this.months=[];
          this.loaderService.hide();
      }
}

  addItem(newItem: string) { 
    
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }
   public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      //console.log(e);
    }
}
